<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <h3>{{ pageTitle }}</h3>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('prisonerNumber', $event.toUpperCase())"
            :value="filters.prisonerNumber"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>Sender Name</label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('senderName', $event)"
            :value="filters.senderName"
            class="mb-1" placeholder="Enter sender name"
          />
        </section>

        <section class="col-3">
          <label>Status</label>
          <b-form-select @change="updateFilter('status', $event, true)" :value="filters.status" class="mb-1">
            <b-form-select-option value="">All Replies</b-form-select-option>
            <b-form-select-option value="Approved">Approved</b-form-select-option>
            <b-form-select-option value="AwaitingConfirmation">Needs Approval</b-form-select-option>
            <b-form-select-option value="Rejected">Rejected</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>Before Date</label>
          <b-form-datepicker @input="updateFilter('before', $event, true)" :value="filters.before" locale="en-uk"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>After Date</label>
          <b-form-datepicker @input="updateFilter('after', $event, true)" :value="filters.after" locale="en-uk"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="updateFilter('sort', $event, true)" :value="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} number (A-Z)</b-form-select-option>
            <b-form-select-option value="-prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} number (Z-A)</b-form-select-option>
            <b-form-select-option value="sender_name">Sender name (A-Z)</b-form-select-option>
            <b-form-select-option value="-sender_name">Sender name (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col align-items-center d-flex" style="margin-top: 7px">
          <div class="ui-spacer"></div>
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchPost()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          :items="post"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(contactName)="data">
            {{data.item.contact ? data.item.contact.firstname : data.item.sender_name}} {{data.item.contact ? data.item.contact.lastname : ''}}
          </template>
          <template #cell(visitorName)="data">
            {{data.item.visitor ? data.item.visitor.firstname : 'External'}} {{data.item.visitor ? data.item.visitor.lastname : 'Contact'}}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(clinician_assigned)="data">
            {{data.item.clinician_assigned ? data.item.clinician_assigned.name : '-'}}
          </template>
          <template #cell(reviewed_by)="data">
            {{getReviewedBy(data.item)}}
          </template>
          <template #cell(status)="data">
            {{ data.item.status === 'AwaitingConfirmation' ? 'Needs Approval' : data.item.status }}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'digital-reply-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No post to show</p>
        </b-row>
      </section>
    </b-card>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import DigitalRepliesService from '@/services/DigitalRepliesService';
import { capitalFirst } from 'echarts/src/util/format';
import HelperService from '../../services/HelperService';

export default {
  name: 'DigitalRepliesSearch',
  components: {},
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: `${this.$options.filters.term('prisoner')} Assigned Name`, key: 'contactName' },
        { label: 'Sent To', key: 'visitorName' },
        { label: 'Status', key: 'status' },
        { label: 'Reviewed By', key: 'reviewed_by' },
        { label: 'Updated', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
      post: [],
      currentPage: 1,
      totalRows: 10,
    };
  },
  computed: {
    ...mapState({
      filters: state => state.digitalReplies.filters,
    }),
    pageTitle() {
      const { status } = this.filters;

      let title = 'All Digital Replies';
      if (status === 'AwaitingConfirmation') {
        title = 'Digital Replies Needing Approval';
      } else if (status === 'Approved') {
        title = 'Approved Digital Replies'
      } else if (status === 'Rejected') {
        title = 'Rejected Digital Replies';
      }

      return title;
    },
  },
  watch: {
    currentPage() {
      this.getPost();
    },
  },
  mounted() {
    this.getPost();
  },
  methods: {
    capitalFirst,
    searchPost() {
      this.currentPage = 1;
      this.getPost();
    },
    getPost() {
      this.updateFilter('skip', (this.currentPage - 1) * this.filters.limit);

      DigitalRepliesService.getAll(this.filters).then(res => {
        this.loading = false;
        this.post = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting post ', err);
        this.$toast.error('Could not get post, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getReviewedBy(post) {
      if (post.status === 'Requested' || post.status === 'AwaitingConfirmation' || post.status === 'Rejected') {
        return '-'
      }
      if (post.reviewer && post.reviewer.name) {
        return post.reviewer.name
      }
      return 'System';
    },
    updateFilter(filterName, e, refresh) {
      this.$store.commit('digitalReplies/SET_FILTER_ITEM', { name: filterName, value: e });

      if (refresh) {
        this.searchPost();
      }
    },
    clearFilters() {
      this.$store.dispatch('digitalReplies/setFiltersToDefault');
      this.searchPost();
    },
  },
};
</script>
